export default __webpack_public_path__ + "static/media/logo_placeholder.352a3c5c.png";